import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Supplier } from 'models/SupplierModel';
import { apiClient } from 'services/tokenInterceptor';

const SupplierForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.SUPPLIER, Code.Form.Name.SUPPLIER];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Supplier>({});
  const [cityOptions, setCityOptions] = Hooks.Form.Options();

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.Http(Code.File.ACCOUNT+Code.File.TYPE, Code.Option.Common.SELECT, setTypeOptions, setError);
    Files.Json.API(Code.File.CITY, Code.Option.Common.NA, setCityOptions, setError);
  
    API.Data.GetByKeyId<Supplier>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.supplier_active); 
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
      }})
      setLoading(false);
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
      supplier_name: Utility.Convert.TitleCase(formData.supplier_name),
    });

    console.log("------------------>",finalData);

    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  const onTestClicked = async () => {
    try {
        const response = await apiClient.get("https://api.nextvizon.com/api/v1/custom/supplier/test");
        console.log("response.data---->", response.data);
      } catch (error: any) {
        if (error.response) {
          console.error(error.response);
        } 
      }
  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege} />
          <Control.Tab.Header titles={["Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
 
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Box>
                <Field.Text id={Name.Supplier.Name} value={formData.supplier_name} title={Title.Supplier} onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} />
                <Field.Text id={Name.Supplier.Person} value={formData.supplier_person} title="Contact person" onChange={(e) => Form.Field.Change(e, formData, setFormData)}  />
              </Control.Box>
              <Control.Row>
                <Field.Text id={Name.Supplier.Phone} value={formData.supplier_phone} title={Title.Phone} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]}  />
                <Field.Text id={Name.Supplier.Email} value={formData.supplier_email} title={Title.Email} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.User.Address} value={formData.supplier_address} title={Title.Address} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
              <Control.Row>
                <Field.Select id={Name.City.Id} value={formData.city_id} title={Title.City} options={cityOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)}  size={[0,50,1]}  />
                <Field.Text id={Name.User.Postal} value={formData.supplier_postal} title={Title.Postal} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Box>
                <Field.Text id={Name.Supplier.Web} value={formData.supplier_web} title="Website" onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
                <Field.Text id={Name.Supplier.Fax} value={formData.supplier_fax} title="Fax No" onChange={(e) => Form.Field.Change(e, formData, setFormData)}  />
                <Field.Text id={Name.Supplier.License} value={formData.supplier_license} title="License No" onChange={(e) => Form.Field.Change(e, formData, setFormData)}  />
              </Control.Box>
              <Control.Row>
                <Field.Text id={Name.Supplier.RefNo} value={formData.supplier_ref_number} title={Title.Refno} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
                <Field.Amount id={Name.Supplier.Limit} value={formData.supplier_limit} title="Credit Limit" onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
              </Control.Row>
              <Control.Row>
                <Button.Action title={'test'} info={"test"} onClick={onTestClicked} />
              </Control.Row>
            </Control.Tab.Content>
            
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default SupplierForm;